export default () => {
    let modalTrigger = document.querySelectorAll('.js-modal, a[href^="!"]');
    let _body = document.body;
    let modalFormInput = document.querySelector('.modal input[name="message[Interesse]"]');

    modalTrigger.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();

            let href = item.attributes.href;

            if (href) {
                let hrefValue = href.nodeValue;
                let match = hrefValue.match(/\((.*?)\)/);

                if (match && match[1]) {
                    modalFormInput.value = decodeURI(match[1]);
                }
            }

            _body.classList.toggle('modal-show');
        });
    });
}